export const CTA_CLICK_LINK = "https://wazirx.com/signup";
export const ALLOWED_CTALINKS_BASE_URL = [
  "https://wazirx.onelink.me/",
  "https://m.wrx.gg/",
];
